export default function () {
  return {
    ayudas: [],
    paginas:[]
  };
}
